module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Message_01-630b6f90b43a3ddf5a8c61daad2556af.jpg";